import { __module as o } from "./chunk677.js";
import { __require as p } from "./chunk447.js";
import { __require as t } from "./chunk464.js";
var a = o.exports, s;
function m() {
  return s ? o.exports : (s = 1, function(d, u) {
    (function(n, r, i) {
      d.exports = r(p(), t());
    })(a, function(n) {
      return n.pad.ZeroPadding = {
        pad: function(r, i) {
          var e = i * 4;
          r.clamp(), r.sigBytes += e - (r.sigBytes % e || e);
        },
        unpad: function(r) {
          for (var i = r.words, e = r.sigBytes - 1, e = r.sigBytes - 1; e >= 0; e--)
            if (i[e >>> 2] >>> 24 - e % 4 * 8 & 255) {
              r.sigBytes = e + 1;
              break;
            }
        }
      }, n.pad.ZeroPadding;
    });
  }(o), o.exports);
}
export {
  m as __require
};
